import router from "../router";
import iView from "iview";
export default {
  IsSupportFile(str) {
    str = str.toLowerCase();
    if (
      str === "jpg" ||
      str === "png" ||
      str === "tiff" ||
      str === "tif" ||
      str === "jpeg" ||
      str === "ppt" ||
      str === "pptx" ||
      str === "pptm" ||
      str === "xls" ||
      str === "xlsx" ||
      str === "xlsm" ||
      str === "doc" ||
      str === "docx" ||
      str === "txt" ||
      str === "docm" ||
      str === "prn" ||
      str === "pdf"
    ) {
      return true;
    } else return false;
  },
  Jump: {
    open(path = "/", params = {}) {
      router.push({
        path,
        query: params
      });
    },
    Back() {
      window.history.go(-1);
    },
    Redirect(path) {
      router.replace({
        path
      });
    }
  },
  com: {
    generateMixed(n) {
      let chars = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
      ];
      let res = "";
      for (let i = 0; i < n; i++) {
        let id = Math.ceil(Math.random() * 35);
        res += chars[id];
      }
      return res;
    }
  },
  check: {
    checkMobile(tel) {
      var re = /^1\d{10}$/;
      if (!re.test(tel)) return false;
      return true;
    },
    isEmail(mail) {
      var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (filter.test(mail)) {
        return true;
      } else {
        return false;
      }
    },
    checkRate(value) {
      var re = /^[1-9]+[0-9]*]*$/;
      if (!re.test(value)) {
        return false;
      }
      return true;
    }
  },
  Message: {
    test() {
      const msg = this.$Message.loading({
        content: "Loading...",
        duration: 0
      });
      setTimeout(msg, 3000);
    }
  },
  IsLogin(jump = true) {
    if (!sessionStorage.user && jump) {
      this.Jump.Redirect("/");
      return false;
    }
    if (!sessionStorage.user && !jump) return false;
    if (sessionStorage.user) return true;
  }
};
